/**
 * "New" ribbon flutter: the card ribbon ([data-badge-new]) stays pinned at its
 * top edge and waves like a flag, a short ripple then a rest, on a loop. Each
 * ribbon only animates while it is on screen (paused when scrolled away), with
 * a random offset so a row of cards doesn't move in lockstep. Ribbons added
 * later (filters, pagination, recommendations, size change) are picked up too.
 * Skipped for reduced motion. Uses the Web Animations API so it never depends
 * on a CSS rebuild.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof Element.prototype.animate !== 'function') return;

  // Pinned at the top centre; only the hanging end moves. First half waves, second half rests.
  const KEYFRAMES = [
    { transform: 'rotate(0deg) skewX(0deg)', offset: 0 },
    { transform: 'rotate(4deg) skewX(-6deg)', offset: 0.1 },
    { transform: 'rotate(-3.5deg) skewX(5deg)', offset: 0.2 },
    { transform: 'rotate(2.5deg) skewX(-3.5deg)', offset: 0.3 },
    { transform: 'rotate(-1.5deg) skewX(2deg)', offset: 0.4 },
    { transform: 'rotate(0deg) skewX(0deg)', offset: 0.5 },
    { transform: 'rotate(0deg) skewX(0deg)', offset: 1 },
  ];
  const DURATION = 3200;

  const animations = new WeakMap();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const ribbon = entry.target;
      let animation = animations.get(ribbon);
      if (entry.isIntersecting) {
        if (!animation) {
          ribbon.style.transformOrigin = '50% 0';
          animation = ribbon.animate(KEYFRAMES, {
            duration: DURATION,
            iterations: Infinity,
            easing: 'ease-in-out',
            delay: Math.random() * 1200,
          });
          animations.set(ribbon, animation);
        } else {
          animation.play();
        }
      } else if (animation) {
        animation.pause();
      }
    });
  }, { threshold: 0.3 });

  const watch = (root) => {
    const ribbons = root.matches?.('[data-badge-new]') ? [root] : root.querySelectorAll?.('[data-badge-new]') || [];
    ribbons.forEach((ribbon) => observer.observe(ribbon));
  };

  watch(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) watch(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
